import * as React from 'react';
import * as UserActionCreators from "../../actions/user.actions";
import * as classNames from "classnames";
import * as DTOS from "../../FeralScan.dtos";
import { withTheme } from '../../common/withTheme';
import { LocalForm, Control, Errors } from 'react-redux-form';
import { matchingPassword, isWeakPassword } from '../Common/validators';
import { Redirect } from 'react-router';
import InternalClassificationLink from '../Framework/Common/Links/InternalClassificationLink';

export type PasswordChangeActions = {
    changePassword: typeof UserActionCreators.changePassword;
    changePasswordFromToken: typeof UserActionCreators.changePasswordFromToken;
}

export type PasswordChangeProps = {
    theme?: string;
    currentUser: DTOS.User;
    loginActive: boolean;
    changePasswordToken: string;
}

export type PasswordChangePropsAndActions = PasswordChangeProps & PasswordChangeActions;

interface IPasswordChangeState {
    submitted: boolean
}

class PasswordChange extends React.PureComponent<PasswordChangePropsAndActions, IPasswordChangeState> {
    formDispatch;
    constructor(props, context) {
        super(props, context);
        this.onChangePassword = this.onChangePassword.bind(this);

        this.state = {
            submitted: false
        }
    }

    onChangePassword(token: string, newPassword: string) {
        this.setState({
            submitted: true
        })

        if (token) {
            this.props.changePasswordFromToken(token, newPassword);
        } else {
            this.props.changePassword(newPassword);
        }
    }


    render() {

        const redirect = <Redirect to="/user" />

        return (<>
            {this.state.submitted ? redirect : undefined}
            <h3>Change Password</h3>
            <p>Please enter a new password.</p>
            <LocalForm
                model="passwordChange"
                className={classNames(this.props.theme, "form")}
                onSubmit={passwordChange => this.onChangePassword(this.props.changePasswordToken, passwordChange.password)}
                getDispatch={(dispatch) => this.formDispatch = dispatch}
                validateOn="submit"
                validators={{
                    '': {
                        matching: matchingPassword,
                        isWeakPassword: isWeakPassword
                    }
                }}>
                <div className="form-fields">
                    <label className="lead">New Password</label>
                    <Control.text
                        model=".password"
                        id="passwordChange.password"
                        type="password"
                        className="form-control form-control-sm mb-2"
                        maxLength={100}
                        required={true}
                    />
                    <label className="lead mt-2">Confirm Password</label>
                    <Control.text
                        model=".passwordConfirm"
                        id="passwordChange.passwordConfirm"
                        type="password"
                        className="form-control form-control-sm mb-2"
                        maxLength={100}
                        required={true}
                    />
                    <Errors
                        model="passwordChange"
                        messages={{
                            matching: "Passwords do not match",
                            isWeakPassword: "Weak password. Use at least 8 characters of upper case, lower case and digits."
                        }}
                        component={(props) => <div className="text-danger">{props.children}</div>}
                    />
                    <div className="d-flex flex-column flex-md-row justify-content-between mt-2">
                        {InternalClassificationLink("user", "CANCEL", undefined, "btn btn-danger btn-lg")}
                        <button className={classNames(this.props.theme, "btn btn-primary btn-lg")}>CHANGE</button>
                    </div>
                </div>
            </LocalForm>
        </>);
    }
}

export default withTheme<PasswordChangePropsAndActions>(PasswordChange);